module.exports = __webpack_public_path__ + "static/logo-dc9e4b91d8f299ee215be3bb95798026.png";